import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	type AskSecondReviewPayload,
	httpAskSecondReview
} from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { MM_PARKING_LOT_QUERY_KEY } from './use-get-mm-parking-lot'

export const useAskSecondReview = (
	options?: Omit<
		UseMutationOptions<unknown, unknown, AskSecondReviewPayload>,
		'mutationFn'
	>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload: AskSecondReviewPayload) =>
			httpAskSecondReview(payload),
		...options,
		onSuccess: (...args) => {
			queryClient.invalidateQueries({
				queryKey: [MM_PARKING_LOT_QUERY_KEY]
			})
			options?.onSuccess?.(...args)
		},
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
}
